/* eslint-disable prettier/prettier */ import Zoomist from 'zoomist';
var parking = function() {
    var data = typeof dataParkings != 'undefined' ? dataParkings : [
        {
            num: '\u041a027',
            status: 'status_0',
            price: 1120000,
            square: 7,
            floor: 1
        }
    ];
    var parkingPlaces = document.querySelectorAll('.parking__schema rect');
    var radios = document.querySelectorAll('input[name="parking__floor"]');
    var info = document.querySelector('.parking__place-info');
    var closeMob = document.querySelector('.parking__place-info-close ');
    var zoomistBl = document.querySelector('.zoomist-container');
    var zoomist;
    if (zoomistBl) {
        zoomist = new Zoomist('.zoomist-container', {
            maxScale: 3,
            zoomer: true,
            zoomRatio: 0.5,
            wheelable: false
        });
    }
    var activeFloor = 1;
    if (window.innerWidth > 1000) {
        if (info) {
            info.addEventListener('mouseleave', function() {
                info.classList.remove('active');
            });
        }
        zoomist === null || zoomist === void 0 ? void 0 : zoomist.destroy();
    }
    radios.forEach(function(el) {
        el.addEventListener('change', function() {
            if (el.value === '2') {
                document.querySelector('.parking__schema.floor1').classList.remove('active');
                document.querySelector('.parking__schema.floor2').classList.add('active');
                activeFloor = 2;
            } else {
                document.querySelector('.parking__schema.floor2').classList.remove('active');
                document.querySelector('.parking__schema.floor1').classList.add('active');
                activeFloor = 1;
            }
            zoomist === null || zoomist === void 0 ? void 0 : zoomist.reset();
        });
    });
    parkingPlaces.forEach(function(place) {
        place.addEventListener('click', function(e) {
            info.classList.add('active');
            info.querySelector('.parking__place-info-title').innerText = "".concat(place.getAttribute('data-parking-id'), " машино-место");
            info.querySelector('.parking__place-info-floor').innerText = "-".concat(activeFloor, " этаж");
            info.querySelector('.parking__place-info-square').innerHTML = "".concat(dataParkings.filter(function(park) {
                return park.num.toString() === place.getAttribute('data-parking-id');
            })[0].square, " м&sup2;");
            console.log(dataParkings.filter(function(park) {
                return park.num.toString() === place.getAttribute('data-parking-id');
            })[0]);
            if (window.innerWidth > 1000) {
                info.setAttribute('style', "\n          top: ".concat(e.offsetY + info.getBoundingClientRect().height / 2, "px;\n          left: ").concat(place.getBoundingClientRect().left + 15, "px\n        "));
            } else {
                info.setAttribute('style', "\n          top: ".concat(window.innerHeight / 2 - info.getBoundingClientRect().height / 2, "px;\n          left: ").concat(window.innerWidth / 2 - info.getBoundingClientRect().width / 2, "px;\n        "));
            }
        });
        var num = place.getAttribute('data-parking-id');
        var status;
        var dataPlace = dataParkings.filter(function(el) {
            return el.num.toString() === num;
        });
        if (dataPlace.length > 0) {
            status = dataPlace[0].status;
        } else {
            status = 'sold';
        }
        if (status === 'sold') {
            place.classList.add('sold');
        } else if (status === 'reserve') {
            place.classList.add('reserve');
        } else {
            place.classList.add('active');
        }
    });
    if (closeMob) {
        closeMob.addEventListener('click', function() {
            info.classList.remove('active');
        });
    }
    window.addEventListener('resize', function() {
        if (window.innerWidth > 1000) {
            zoomist === null || zoomist === void 0 ? void 0 : zoomist.destroy();
        } else {
            zoomist === null || zoomist === void 0 ? void 0 : zoomist.init();
        }
    });
    if (info) {
        document.addEventListener('click', function(e) {
            if (e.target.tagName !== 'rect') {
                info.classList.remove('active');
            }
        });
    }
};
export default parking;
